import {
  ICityOption,
  IHospitalData,
  ResponseType,
} from "../types/dropdown-with-pop-up-types.types";
import { API_PATHS } from "../constants/api-paths";
import { logErrorToNewRelic } from "../utils/logging";
import { request } from "../core/api.client";

export const fetchProviderNames = async () => {
  try {
    const response: ResponseType = await request({
      method: "GET",
      url: API_PATHS.hospitalProviders,
    });
    if (response.statusCode === 99) {
      return [];
    }
    return response.data.providers;
  } catch (error) {
    logErrorToNewRelic(error as Error);
    return [];
  }
};

export const fetchCityNames = async (searchKeyword: string) => {
  try {
    const response = <{ data: { cities: ICityOption[] }; statusCode: number }>await request({
      method: "POST",
      url: API_PATHS.hospitalCities,
      data: { searchKeyword },
    });
    if (response.statusCode === 99) {
      return [];
    }
    return response.data.cities;
  } catch (error) {
    logErrorToNewRelic(error as Error);
    return [];
  }
};

export const fetchHospitalList = async (cityId: string, providerId: string) => {
  try {
    const response = <{ data: { lists: IHospitalData[] }; statusCode: number }>await request({
      method: "POST",
      url: API_PATHS.hospitalList,
      data: { cityId, providerId },
    });
    if (response.statusCode !== 90) {
      return [];
    }
    return response.data.lists;
  } catch (error) {
    logErrorToNewRelic(error as Error);
    return [];
  }
};
